import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContractorForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(`${API}/contractors/forgot-password`, { email });
      setIsSuccess(true);
      toast.success("Email envoyé avec succès");
    } catch (error) {
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="forgot-password-success">
        <div className="w-full max-w-md text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-slate-900 mb-3">
            Email envoyé !
          </h1>
          <p className="text-slate-600 mb-8">
            Si un compte existe avec l'adresse <strong>{email}</strong>, vous recevrez un <strong>lien de réinitialisation</strong> par email.
            Cliquez dessus pour choisir un nouveau mot de passe. Le lien est valable <strong>1 heure</strong> et à usage unique.
          </p>
          <p className="text-sm text-slate-500 mb-6">
            Pensez à vérifier vos spams si vous ne recevez pas l'email.
          </p>
          <Link to="/espace-entrepreneur/login">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white">
              Retour à la connexion
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">
            Mot de passe oublié
          </h1>
          <p className="text-slate-600 mt-2">
            Entrez votre email pour recevoir un lien de réinitialisation
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-8 border border-slate-100">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
            <div>
              <Label htmlFor="email" className="text-slate-700 mb-2 block">
                Adresse email
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="contact@entreprise.be"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-password-email"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading || !email}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-6"
              data-testid="forgot-password-button"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                  Envoi en cours...
                </>
              ) : (
                "Envoyer le lien de réinitialisation"
              )}
            </Button>
          </form>
        </div>

        <p className="text-center text-sm text-slate-500 mt-6">
          <Link to="/espace-entrepreneur/login" className="hover:text-slate-700 flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
